// extracted by mini-css-extract-plugin
export default {"container":"Name_container__l7v1Z","content":"Name_content__tmhXZ","textContainer":"Name_textContainer__EVrI8"};